<template>
  <div outer fill>
    <div header style="gap: 8px">
      <div style="flex: 1 1 auto; min-width: 72px; display: flex; flex-direction: column; gap: 2px">
        <span v-if="cart.id" ellipsis :title="cart.name">{{ cart.name }}</span>
        <span v-else ellipsis style="color: var(--text-faint)">No cart selected</span>
        <span v-if="cart.id" class="mono" style="display: flex; align-items: center; gap: 6px; font-size: 10px; font-weight: 400; color: var(--text-dim)">
          <span class="pill-dot" :style="{ '--pill': state.color }"></span>{{ state.label }}
        </span>
      </div>
      <div style="margin-left: auto; flex: none; display: flex; align-items: center; gap: 6px">
        <button type="button" class="mv-ghost mv-ghost--sm" :disabled="!subclipCount" title="Export notes as PDF" @click="$store.state.downloadPDF()">Notes PDF</button>
        <button type="button" class="mv-primary" :disabled="!canRestore" title="Submit this cart and start the restore" @click="$store.state.restoreClips()">
          {{ restoring ? "Restoring…" : "Start restore" }}
        </button>
      </div>
    </div>
    <div ref="subclipsListRef" style="flex: 1; min-height: 0; overflow: auto; display: flex; flex-direction: column">
      <CartSubclipListItem v-for="(subclip, index) in cart.subclips" :key="subclip.id" :value="subclip" :position="index + 1"></CartSubclipListItem>
      <div v-if="!subclipCount" style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; padding: 28px 16px; text-align: center">
        <span style="font-size: 13px; font-weight: 600; color: var(--text-dim)">{{ cart.id ? "This cart is empty" : "No cart selected" }}</span>
        <span style="font-size: 12px; color: var(--text-faint)">{{ cart.id ? "Mark In/Out in the player and add a clip." : "Pick a cart, or create one with ＋." }}</span>
      </div>
    </div>
    <div footer>
      <span nowrap>{{ plural(subclipCount, "clip") }}</span>
      <span class="mono" style="margin-left: auto; color: var(--text-faint)" :title="totalTitle">Σ {{ totalLabel(totals, subclipCount) || "—" }}</span>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/scripts/event-bus.js";
import { plural } from "@/scripts/plural.js";
import { cartState } from "@/scripts/assetStatus";
import { cartTotals, totalLabel } from "@/scripts/cartTotals.js";

export default {
  props: {},
  data: () => {
    return {};
  },
  methods: { plural, totalLabel },
  mounted() {
    let that = this;
    EventBus.$on("subcliplist-scroll-bottom", function () {
      const el = that.$refs.subclipsListRef;
      if (el) el.scrollTop = el.scrollHeight;
    });
  },
  computed: {
    subclipCount() {
      return this.$store.state.cart && this.$store.state.cart.subclips ? this.$store.state.cart.subclips.length : 0;
    },
    cart() {
      return this.$store.state.cart;
    },
    /** Known clip lengths summed; clips of unknown length are counted, never guessed. */
    totals() {
      return cartTotals(this.cart.subclips || [], this.$store.state.clipLookups());
    },
    totalTitle() {
      const unknown = this.totals.unknown;
      return unknown ? plural(unknown, "clip") + " of unknown length not counted" : "Total length";
    },
    state() {
      return cartState(this.cart);
    },
    // Queued or rendering on the server, or just submitted from here.
    restoring() {
      return this.state.key === "restoring" || this.$store.state.submittingId === this.cart.id;
    },
    // An empty cart has nothing to restore (without subclips the server cuts whole assets); the server rejects locked carts.
    canRestore() {
      const cart = this.cart;
      const hasContent = this.subclipCount || (cart.assets && cart.assets.length);
      return !!(cart.id && hasContent && !this.restoring && this.state.key !== "locked");
    },
  },
  beforeDestroy() {
    EventBus.$off("subcliplist-scroll-bottom");
  },
};
</script>
